import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;

  overflow: hidden;

  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  border: 1px solid ${Colors.GS500};

  width: 100%;

  padding: 8px 8px 8px 16px;
`

export const Inner = styled.div`
  width: calc(100% - 140px);
  margin-right: 16px;
`

export const Label = styled.div`
  font-size: 12px;
  line-height: 1.3;
  color: ${Colors.GS600};
`

export const Content = styled.div`
  width: 100%;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
